<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="700px" :before-close="handleChangeDrawer" :close-on-click-modal="false">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="90px" label-position="right">
            <el-form-item
              class="flex-row"
              ref="introducerMobile"
              label="介绍人："
              prop="introducerMobile"
            >
            <el-input placeholder="请输入店员手机号/工号" v-model="form.introducerMobile">
                  <el-button slot="suffix" size="mini" type="primary" class="cur elButton" @click="searchStaff">查询</el-button>
                </el-input>
            </el-form-item>
            <el-form-item
              class="flex-row"
              ref="introducer"
              label="姓名："
              prop="introducer"
            >
              {{form.introducer}}
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btns">
            <el-button type="primary" @click="save">确定</el-button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      codeName: true,
      time: 60,
      addEditShow: false,
      addEditTitle: "",
      form: {
        introducerMobile: '',
        introducer: ""
      },
      oldForm: {}
    };
  },
  mixins: [minxin],
  components: {
    
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    searchStaff () {
      // 查询
      console.log(this.form);
      if (!this.form.introducerMobile) {
        this.$message.error('请输入手机号码/工号');
        return false;
      }
      this.$api.get(this.$url.companyShopStaff.getByStaffNoOrMobile, { staffNoOrMobile: this.form.introducerMobile }).then(res => {
        if (res) {
          this.form.introducer = res.staffName;
          this.form.introducerId = res.id;
          console.log(res);
        }
      });
    },
    //  页面初始化函数
    init() {
      this.$on("set", function(item) {
        Object.assign(this.$data, this.$options.data());
        if (item) {
          console.log(item);
          // item.introducer = ""; // 这里的问题
          this.$set(item,'introducerId','');
          this.$set(item,'introducer','');
          // this.$set(item,'introducerMobile','');
          this.form = item;
        }
        this.addEditShow = true;
        this.addEditTitle = "介绍人";
      });
    },
    handleChangeDrawer(val) {
      // this.$refs["form"].clearValidate();
      this.addEditShow = false;
    },
    // 保存
    save () {
      if (!this.form.introducerMobile) {
        this.$message.error('请输入手机号码/工号');
        return false;
      } else if (!this.form.introducer) {
        this.$message.error('请查询介绍人');
        return false;
      }
      this.addEditShow = false;
      sessionStorage.setItem("referencesData", JSON.stringify(this.form))
      this.$emit("change", this.form);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
 
  /deep/ .el-input__suffix {
    right: 10px;
  }
  .elButton {
    height: 30px;
  }
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      background: #fff;
    //   border-bottom: 1px solid @borderColor;
      padding: 10px 0;
      // margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
      
    }
    
  }
}
</style>